import { Input, Modal,  } from 'antd'
import React, { useState } from 'react'
import { connect } from 'react-redux';
import { deleteAnnouncement, fetchAnnouncement, storeAnnouncePage } from 'actions/announcement';
import { Button } from 'components/Button';


const AnnouncementDeleteModal = ({deleteShow,draftButtonLoader,announceButtonLoader,deleteButtonLoader,onOk,onCancel }) => {

    return (
        <div>
            <Modal
                className="modal-round-corner"
                visible={deleteShow}
                footer={null}
                centered={true}
                // width={"60%"}
                closable={true}
                bodyStyle={{ height: "100%" }}
                onCancel={onCancel}
            >
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    <div style={{ fontSize: "18px", fontWeight: "bold" }}>Confirm</div>
                    <div style={{ fontSize: "15px", color: "#636363" }}>Are you sure you want to delete ?</div>
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                        <div>
                            <Button
                                disabled={draftButtonLoader || announceButtonLoader}
                                loading={deleteButtonLoader} type='primary' style={{ fontWeight: "bold", width: '100%', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={onOk}>YES</Button>

                        </div>
                        <div style={{ marginLeft: "20px" }}>
                            <Button type='primary' style={{ fontWeight: "bold", width: '100%', borderRadius: '5px', textAlign: 'center', fontWeight: 'bold' }} onClick={onCancel}>NO</Button>
                        </div>

                    </div>

                </div>

            </Modal>
        </div >
    )
}

const mapStateToProps = (state) => {
 
    return {

    };
};

const mapDispatchToProps = (dispatch) => ({

});

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(AnnouncementDeleteModal);

